<template>
  <v-row>
    <v-btn @click="exportFile">{{ $t('BUTTON.EXPORT') }}</v-btn>
  </v-row>
</template>

<script>
import downloadFile from '@/modules/_global/mixins/download-file';
import { dateFormatUnderscore } from '@/modules/_global/filters';
import { mapActions } from 'vuex';

export default {
  name: 'ExportBuildings',

  mixins: [downloadFile],

  props: {
    options: {
      type: Object,
      default: () => {}
    }
  },

  methods: {
    ...mapActions('company', ['getCompaniesExport']),

    exportFile() {
      this.getCompaniesExport(this.options)
        .then(response => {
          const filename = this.$t('COMPANIES.ITEMS');
          const date = dateFormatUnderscore(new Date());

          this.downloadFile(response, `${filename} ${date}.xlsx`);
        })
        .catch(error => {
          this.$emit('error', error);
        });
    }
  }
};
</script>
